/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let chatRoomCreatedUrl = root.chatRoomCreateUrl.link;
let ChatConnectionRequestUrl = root.chatConnectionRequestUrl.link;
let RequestApprovedURl = root.requestApprovedUrl.link;
let ChatBrowserNotificationtUrl = root.chatBrowserNotificationtUrl.link;
let userSupportHelpApiURL = root.userSupportHelpApiUrl.link;
let groupChatListApiURL = root.groupChatListApiUrl.link;


export default {
  state: {
    teamWorkspaceState: {},
    chatConnectionRequestListState: {},
    ChatBrowserNotificationtState: {},
    getGroupChatListState: {}
  },
  mutations: {
    getGroupChatListMut(state, value) {
      Vue.set(state, 'getGroupChatListState', value);
    },
    teamWorkspaceMut(state, value) {
      Vue.set(state, 'teamWorkspaceState', value);
    },
    chatConnectionRequestListMut(state, value) {
      Vue.set(state, 'chatConnectionRequestListState', value);
    },
    ChatBrowserNotificationtMuatation(state, value) {
      Vue.set(state, 'ChatBrowserNotificationtState', value);
    },
  },
  actions: {
    // Get Group Chat Room List
    getGroupChatRoomCreatedFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(groupChatListApiURL, payload).then(res => {
          context.commit('getGroupChatListMut', res.data);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    // Get Chat Room Create
    chatRoomCreatedFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(chatRoomCreatedUrl, payload).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    // Get User Support Help Chat List
    getUserSupportHelpChatDetailsByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(userSupportHelpApiURL + payload.id + '/', payload).then((res) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      })
    },
    // MSg Read Status Function
    chatConnectionRequestListFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(ChatConnectionRequestUrl, payload).then((res) => {
          context.commit('chatConnectionRequestListMut', res);
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      })
    },
    // MSg Read Status Function
    SendChatConnectionRequestFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(ChatConnectionRequestUrl, payload).then((res) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      })
    },
    // Chat Request Apporved
    apporvedConnectionRequestFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(RequestApprovedURl + payload.data.id + '/', payload.data.data).then((res) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      })
    },
    // Browser Notification
    chatBroserNotificationFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(ChatBrowserNotificationtUrl, payload).then((res) => {
          context.commit('ChatBrowserNotificationtMuatation', res.data);
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      })
    },
  },
  getters: {
    teamWorkspaceGetters: state => state.teamWorkspaceState,
    chatConnectionRequestListGetters: state => state.chatConnectionRequestListState,
    workspaceUserNotificationGetters: state => state.ChatBrowserNotificationtState,
    getGroupChatListGetter: state => state.getGroupChatListState
  }
}